import React from "react";
import { Slide } from "react-reveal";
import ServicesList from "../reusables/ServicesList";

const CoreMarkets = () => {
  return (
    <section className="section section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content">
            <div className="width-600">
              <p className="section-name boldTitle light-blue">
                JMSTONE LOGISTICS LIMITED
              </p>
              <Slide top>
                <div className="section-head">
                  <h2 className="section-title dark">OUR SERVICES</h2>
                </div>
              </Slide>
            </div>
            <div className="section-body section-spacing-20">
              <ServicesList />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoreMarkets;
